export { Favicon } from "./Favicon";
